/**
 * Central route path constants. Use these (and the builders for dynamic
 * segments) instead of hard-coded string literals in router config and
 * navigate() calls.
 */
export const ROUTES = {
  LOGIN: "/",
  HOME: "/home",
  PROJECT: (id: string) => `/home/${id}`,
  REPORTING: (id: string) => `/reporting/${id}`,
  AUTOMATION: "/automation",
  DOCS: "/docs",
  DOCS_PAGE: (section: string, page: string) => `/docs/${section}/${page}`,
  SUPERADMIN: "/superadmin",
} as const

/** Router path patterns (with param placeholders). */
export const ROUTE_PATTERNS = {
  LOGIN: "/",
  HOME: "/home",
  PROJECT: "/home/:id",
  REPORTING: "/reporting/:id",
  AUTOMATION: "/automation",
  DOCS: "/docs/:section?/:page?",
  SUPERADMIN: "/superadmin",
} as const
